import React from 'react';

import * as BoxC from "./_ccbBoxC";
import * as IptC from "./_ccbIptC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as BtnC from "./_cccBtnC";
import * as cmFTH from "./_cmFTH"; // 廃止予定
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ls from "./_csLcl"; // local state
import { useMsgz } from "./_csMdlMsg";
import * as _cv_10___Mz from "./_cv_10___Mz";
import * as _cv_31___Mz from "./_cv_31___Mz";
import * as _cv_40___Mz from "./_cv_40___Mz";
import * as _cv_60___Mz from "./_cv_60___Mz";
import * as _ht from './_ht';
import * as _hm from './_hf';
import * as _hmDTM from './_hfDTM';

import * as ihd from './ihd';
import * as ihv from './ihv';
import * as icm from './icm';
import * as icv from './icv';

import * as icvi10 from './icvI10___Mz';
import * as icvi17 from './icvI17___Mz';

let $i10rs = [] as _ht.ls;
let $i17rs = [] as _ht.ls;
let $_601s = [] as _ht.ls;

export const T = (pz: {
  sPz: _ht.dz,
  frcUdt: () => void,
  boxStlz?: _ht.boxStlz,
  cz: {
    bEdit: _ht.b,
    i1zz: _ht.dz,
    _31r_fst: _ht.n,
  },
}) => {

  const _sMdlMsgz = useMsgz();

  const _frcUdt = ls.frcUdt();

  React.useEffect(() => {
    cmFTH.loadAllAsync({
      frcUdt: _frcUdt,
      bfrAsync: () => [
        icvi10.loadI10rLsAsync({
          _31r_fst: pz.cz._31r_fst,
          lwrType: 1,
        })
        .then( (_ls: _ht.ls) => {
          $i10rs = _ls;
        }),
        icvi17.loadI17rLsAsync({
          _31r_fst: pz.cz._31r_fst,
        })
        .then( (_ls: _ht.ls) => {
          $i17rs = _ls;
        }),
      ]
    })
  }, [
    pz.cz._31r_fst
  ])

  React.useEffect(() => {
    _hm.ectSrlAsync([
      async () => {
        const _date = pz.cz.i1zz.i1zrz.i1zrd3100s ?? _hmDTM.getTdy();
        $_601s = await _cv_60___Mz.load_601AsAsync({ // 祝日
          dates: _hmDTM.grtDates(_hmDTM.cvtFdm(_date), _hmDTM.cvtLdm(_date)),
        });
        _frcUdt();
      }
    ])
  }, [
    pz.cz.i1zz.i1zrz.i1zrd3100s
  ])

  const _udtI1z1s = async () => {
    _hm.udtDz(pz.cz.i1zz.i1z3z, icm.udtI1z3z({
      i1zz: pz.cz.i1zz,
      i17rs: $i17rs,
    }));
    pz.frcUdt();

  };

  const _hdrs = [] as _ht.ls;

  _hdrs.push(
    {
      cellCs: [
        {
          boxStlz:  a('dw/20 f/n fd/rsc mr/1'),
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              abtType: 'lblStfz',
              textz: {
                pfx: '利用日'
              }
            })
          ]
        },
        {
          boxStlz:  a('dw/f fd/rsc mr/1'),
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              abtType: 'lblStfz',
              textz: {
                pfx: '利用する部屋'
              },
            })
          ]
        },
        {
          boxStlz:  a('dw/f fd/rsc mr/1'),
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              abtType: 'lblStfz',
              textz: {
                pfx: '利用時間帯'
              }
            })
          ]
        },
        {
          boxStlz:  a('dw/f fd/rsc mr/1'),
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              abtType: 'lblStfz',
              textz: {
                pfx: '開始時刻'
              }
            })
          ]
        },
        {
          boxStlz:  a('dw/f fd/rsc mr/1'),
          oClds: [
            cr.c(TextC.N, {
              key: -10,
              abtType: 'lblStfz',
              textz: {
                pfx: '利用料金'
              }
            })
          ]
        },
        pz.cz.bEdit != false ?
        {
          boxStlz:  a('dw/btn f/n mr/1'),
          oClds: [
          ]
        }
        : null,
      ]
    }
  );

  const _dateCs = [] as _ht.ls;

  _dateCs.push(
    cr.c(IptC.S, {
      key: -10,
      cz: {
        bEdit: pz.cz.bEdit && pz.sPz.crt.steps[0] != 3, // 予約・エントリー状況の更新を考慮し、編集モードでは変更不可
        iptType: 'dtm',        
        vle: pz.cz.i1zz?.i1zrz.i1zrd3100s,
        onChg: ( _date: _ht.s ) => {
          pz.cz.i1zz.i1zrz.i1zrd3100s = _date;
          _hm.getRng(icv.nI1z1CntMax-1, 0).map( ( _nIdx: _ht.n ) => {
            if (!pz.cz.i1zz?.i1z1s[_nIdx]) pz.cz.i1zz.i1z1s[_nIdx] = {};
            const _i1z1z = pz.cz.i1zz.i1z1s[_nIdx];
            const _dz3 = icm.grtI1z1z({
              i1z1d1100s: pz.cz.i1zz.i1zrz.i1zrd3100s,
              i10r_fst: _i1z1z.i1z1i10r1f,
              i10rs: $i10rs,
              i111_fst: _i1z1z.i1z1i1111f,
              i15ra6100i: 1,
              _601s: $_601s,
            });
            _hm.udtDz(_i1z1z, _dz3);
          });
          _udtI1z1s();
        },
      },
    })
  );

  const _rowCs = [] as _ht.ls;

  if (pz.cz.i1zz) {
    let _cnt = 0;
    let _idx = 0;
    while ( _cnt < icv.nI1z1CntMax ) {
      if ( pz.cz.i1zz.i1z1s[_idx] ) {
        if (pz.cz.i1zz?.i1z1s[_idx]._dlt != 1) {
          _cnt += 1
        }
      }
      else {
        pz.cz.i1zz.i1z1s[_idx] = {};
        _cnt += 1;
      }
      _idx += 1;
    }
  }

  pz.cz.i1zz?.i1z1s?.filter((_dz: _ht.dz) => _dz._dlt != 1 ).sort((_i1z1z1: _ht.dz, _i1z1z2: _ht.dz) => {
    if (_i1z1z1.i1z1i1111f > _i1z1z2.i1z1i1111f) return  1;
    if (_i1z1z1.i1z1i1111f < _i1z1z2.i1z1i1111f) return -1;
    return 0;
  }).map(( _i1z1z: _ht.dz, _idx: _ht.n ) => {


    _rowCs.push({
      boxStlz: 
        _idx != 0 ?
          a('bc/lt3 bwt/1 pt/0.25 pb/0.25')
        : a('bc/t bwt/1 pt/0.25 pb/0.25'),
      cellCs: [
        {
          boxStlz:  a('dw/f fd/rsc mr/1'),
          oClds: [
            cr.c(IptC.S, { // 部屋
              key: -10,
              cz: {
                bEdit: pz.cz.bEdit,
                iptType: 'pcr',
                ls: 
                  pz.sPz.crt.steps[0] == 3 ?  // 予約・エントリー状況の更新を考慮し、編集モードでは既存のもののみ選択可
                    $i10rs.filter((i10rz: _ht.dz) => {
                      let _bChk = false;
                      pz.cz.i1zz.i1z1s.map((i1z1z: _ht.dz) => {
                        if (i10rz._fst == i1z1z.i1z1i10r1f ) _bChk = true; 
                      });
                      return _bChk;
                    })
                  : $i10rs,
                vle: _i1z1z?.i1z1i10r1f,
                onChg: ( _dz: _ht.dz ) => {
                  const _dz3 = icm.grtI1z1z({
                    i1z1d1100s: pz.cz.i1zz.i1zrz.i1zrd3100s,
                    i10r_fst: _dz._fst,
                    i10rs: $i10rs,
                    i111_fst: _i1z1z.i1z1i1111f,
                    i15ra6100i: 1,
                    _601s: $_601s,
                  });
                  _hm.udtDz(_i1z1z, _dz3);
                  _udtI1z1s();
                },
                bfrFcsAsync: async () => {
                  if (_hm.f(pz.cz.i1zz.i1zrz.i1zrd3100s)) {
                    return true;
                  }
                  else {
                    _sMdlMsgz.show({
                      textCz: {
                        textz: {
                          pfx: '利用日を先に選択ください。',
                          stlz: a('tc/lt9'),
                        }
                      }
                    });
                    return false;
                  }
                },
              },
            })
          ]
        },
        {
          boxStlz:  a('dw/f fd/rsc mr/1'),
          oClds: [
            cr.c(IptC.S, { // 時間帯
              key: -10,
              cz: {
                bEdit: pz.cz.bEdit, // 予約・エントリー状況の更新を考慮し、新規追加モードか利用時間帯がある場合のみ変更不可
                iptType: 'pcr',
                ls: icm.getI111s({
                  i10r_fst: _i1z1z?.i1z1i10r1f,
                  i10rs: $i10rs,
                })?.concat([ihv.otrz]),
                vle: _i1z1z?.i1z1i1111f,
                onChg: ( _dz: _ht.dz ) => {
                  const _dz3 = icm.grtI1z1z({
                    i1z1d1100s: pz.cz.i1zz.i1zrz.i1zrd3100s,
                    i10r_fst: _i1z1z.i1z1i10r1f,
                    i10rs: $i10rs,
                    i111_fst: _dz._fst,
                    i15ra6100i: 1,
                    _601s: $_601s,
                  });
                  _hm.udtDz(_i1z1z, _dz3);
                  _udtI1z1s();
                },
                bfrFcsAsync: async () => {
                  if (_hm.f(_i1z1z.i1z1i10r1f)) {
                    return true;
                  }
                  else {
                    _sMdlMsgz.show({
                      textCz: {
                        textz: {
                          pfx: '部屋を先に選択ください。',
                          stlz: a('tc/lt9'),
                        }
                      }
                    });

                  }
                }
              },
            })
          ]
        },
        {
          boxStlz:  a('dw/f fd/rsc mr/1'),
          oClds: [
            cr.c(IptC.S, { // 開始時刻
              key: -10,
              iptStlz: a('ta/r'),
              cz: {
                bEdit: 
                  pz.cz.bEdit && _i1z1z?.i1z1i1111f == ihv.otrz._fst ?
                    true
                  : false,
                iptType: 'pcr',
                ls: ihd.f(`i1z1a1100i`).ls,
                vle: _i1z1z?.i1z1a1100i,
                onChg: ( _dz: _ht.dz ) => {
                  _i1z1z.i1z1a1100i = _dz.key;
                  if ( _i1z1z.i1z1i1111f == ihv.otrz._fst ) {
                    _i1z1z.i1z1a1200i = _i1z1z.i1z1a1100i + 1;
                  }
                  _udtI1z1s();
                }
              },
            }),
          ]
        },
        {
          boxStlz:  a('dw/f fd/rsc mr/0'),
          oClds: [
            cr.c(IptC.S, { // 利用料
              key: -10,
              iptStlz: a('ta/r tb'),
              cz: {
                bEdit: false,
                iptType: 'text',
                vle: `${_hm.cvtCmm(_i1z1z?.i1z1m1100i ?? 0)}`,
              },
            }),
            cr.c(TextC.N, { // 利用料
              key: -20,
              textz: {
                pfx: '円',
              }
            })
          ]
        },
        pz.cz.bEdit != false?
        {
          boxStlz: a(`dw/btn f/n fd/rcc ml/1 sc/rd1`),
          oClds: [
            cr.c(BoxC.N, {
              key: -10,
              oClds: [
                cr.c(BtnC.N, {
                  key: -10,
                  abtType: 'dltIconz',
                  bfrIconCz: {},
                  lblCz:{},
                  pslPtyz: {
                    onPress: () => {
                      _hm.udtDz(_i1z1z, {
                        _dlt: 1,
                      });
                      _udtI1z1s();
                    },
                  }
                })
              ]
            })
          ]
        }
        : 
        null
      ]
    })
  })

  return (
    cr.c(BoxC.N, {
      key: 'icvi10.t.root',
      boxStlz: {
        ... a('dw/f'),
        ... pz.boxStlz,
      },
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'hdrStfz',
          boxStlz: a('dw/f mb/0'),
          lineCs: _hdrs,
        }),

        cr.c(GridC.N, {
          key: -20,
          abtType: 'lineStfz',
          boxStlz: a('dw/f'),
          lineCs: [
            {
              boxStlz: a('mb/0'),
              cellCs: [ 
                {
                  boxStlz: a('dw/20 f/n mr/1'),
                  oClds: _dateCs,
                },
                {
                  oClds: [
                    cr.c(GridC.N, {
                      key: -10,
                      abtType: 'nolineCmnz',
                      lineCs: _rowCs,
                    })
                  ]
                }
              ]
            }
          ],
          msgCz: {
            textz: {
              pfx: '該当なし',
              stlz: a('mb/1'),
            }
          }
        }),

      ]
    })
  );
};
